import { ITranslations } from 'types/common';
import { ParsersTransFields } from './types';
import en from 'translations/en/parsers.json';
import pl from 'translations/pl/parsers.json';
import sl from 'translations/sl/parsers.json';

export const parsersTranslations: ITranslations<ParsersTransFields> = {
  name: 'parsers',
  en,
  pl,
  sl,
};
